import axios from 'axios';
import {YOUTUBE_API_KEY} from '../config';

const ytAxios = axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3/',
    params: { key: YOUTUBE_API_KEY, part: 'snippet', maxResults: 25 },
})

export default ytAxios;